import { getAuthMethod } from "../../../../modules/helper";

const getCity = async (id, setLoading = undefined, set) => {
  if (setLoading !== undefined) setLoading(true);

  const response = await getAuthMethod("/address/v1/get-city", {
    id: id,
  });

  if (setLoading !== undefined) setLoading(false);

  if (response && response.status === 200) set(response.data.city);
};

export default getCity;
